<div [ngStyle]="noBoxShadow ? { 'box-shadow': 'none' } : ''" class="{{ hasBoxStyles ? 'info-box bg-white' : '' }}">
  <div class="row g-2">
    <div class="col col-auto">
      <i [ngClass]="iconClass" class="fa fs-6 text-secondary" aria-hidden="true"></i>
    </div>
    <div class="col">
      @if (text | translate: textParams; as translatedText) {
        <p [attr.data-test]="dataTest" [innerHTML]="translatedText | safeHtml" class="text--large mb-0"></p>
      } @else {
        <ng-content />
      }
    </div>
  </div>
</div>
